import { useEffect } from "react";

const SITE_URL = "https://marocpratique.com";
const DEFAULT_OG_IMAGE = "https://marocpratique.com/brand/og-image.png";

export default function SEOHead({
  title,
  description,
  canonical,
  image,
  type = "website",
  jsonLd,
  noIndex = false,
}) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content, property = false) => {
      if (!content) return;
      const attr = property ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const ogImage = image || DEFAULT_OG_IMAGE;

    setMeta("description", description);
    setMeta("robots", noIndex ? "noindex, follow" : "index, follow");

    // Open Graph
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:type", type, true);
    setMeta("og:site_name", "MarocPratique", true);
    setMeta("og:locale", "fr_MA", true);
    if (canonical) setMeta("og:url", canonical, true);
    setMeta("og:image", ogImage, true);
    setMeta("og:image:width", "1200", true);
    setMeta("og:image:height", "630", true);

    // Twitter
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:site", "@marocpratique");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:image", ogImage);

    // Canonical
    let canonicalEl = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      if (!canonicalEl) {
        canonicalEl = document.createElement("link");
        canonicalEl.setAttribute("rel", "canonical");
        document.head.appendChild(canonicalEl);
      }
      canonicalEl.setAttribute("href", canonical);
    } else if (canonicalEl) {
      canonicalEl.remove();
    }

    // JSON-LD — supporte un schéma unique ou un tableau de schémas
    // On supprime tous les anciens scripts jsonld avant réinjection
    document.querySelectorAll('script[id^="jsonld-"]').forEach((el) => el.remove());

    if (jsonLd) {
      const schemas = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      schemas.forEach((schema, idx) => {
        const s = document.createElement("script");
        s.id = `jsonld-${idx}`;
        s.type = "application/ld+json";
        s.textContent = JSON.stringify(schema);
        document.head.appendChild(s);
      });
    }

    return () => {
      document.querySelectorAll('script[id^="jsonld-"]').forEach((el) => el.remove());
    };
  }, [title, description, canonical, image, type, jsonLd, noIndex]);

  return null;
}
